var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 53,
    viewBox: "0 0 50 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.4998 25.7498H8.91634C8.59418 25.7498 8.33301 26.0109 8.33301 26.3331V51.9284C8.33301 52.2506 8.59418 52.5118 8.91634 52.5118H41.4998C41.822 52.5118 42.0832 52.2506 42.0832 51.9284V26.3331C42.0832 26.0109 41.822 25.7498 41.4998 25.7498Z",
    fill: "#CCE5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6058 48.929H28.2962C27.9748 48.929 27.7129 49.1909 27.7129 49.5123C27.7129 49.8337 27.9748 50.0956 28.2962 50.0956H37.6058C37.9272 50.0956 38.1891 49.8337 38.1891 49.5123C38.1891 49.1909 37.9272 48.929 37.6058 48.929Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5223 43.524L35.2723 42.774V47.1907C35.2723 47.5122 35.5342 47.7741 35.8557 47.7741C36.1771 47.7741 36.439 47.5122 36.439 47.1907V42.774L37.189 43.524C37.3081 43.6431 37.4509 43.6907 37.6057 43.6907C37.7604 43.6907 37.9033 43.6312 38.0223 43.524C38.2485 43.2979 38.2485 42.9288 38.0223 42.7026L36.2723 40.9526C36.0461 40.7264 35.6771 40.7264 35.4509 40.9526L33.7009 42.7026C33.4747 42.9288 33.4747 43.2979 33.7009 43.524C33.9271 43.7502 34.2961 43.7502 34.5223 43.524Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.702 43.524L29.452 42.774V47.1907C29.452 47.5122 29.7139 47.7741 30.0354 47.7741C30.3568 47.7741 30.6187 47.5122 30.6187 47.1907V42.774L31.3687 43.524C31.4877 43.6431 31.6306 43.6907 31.7854 43.6907C31.9401 43.6907 32.083 43.6312 32.202 43.524C32.4282 43.2979 32.4282 42.9288 32.202 42.7026L30.452 40.9526C30.2258 40.7264 29.8568 40.7264 29.6306 40.9526L27.8806 42.7026C27.6544 42.9288 27.6544 43.2979 27.8806 43.524C28.1068 43.7502 28.4758 43.7502 28.702 43.524Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.965 25.976L36.7269 18.9998C36.6198 18.857 36.4412 18.7617 36.2626 18.7617H14.1554C13.9768 18.7617 13.7982 18.8451 13.6911 18.9998L8.45299 25.976C8.32203 26.1546 8.29822 26.3927 8.40537 26.5832C8.51251 26.7737 8.70299 26.9046 8.91727 26.9046H41.5007C41.7269 26.9046 41.9174 26.7856 42.0127 26.5832C42.1079 26.3808 42.0841 26.1546 41.965 25.976Z",
    fill: "#28345A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9048 3.6189H0V15.5237H11.9048V3.6189Z",
    fill: "#CCE5FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.21059 3.6189H4.68457V7.2537H7.21059V3.6189Z",
    fill: "#019EF7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9048 14.248H0V15.5152H11.9048V14.248Z",
    fill: "#027BC7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9527 0H19.0479V11.9048H30.9527V0Z",
    fill: "#CCE5FF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2584 0H23.7324V3.6348H26.2584V0Z",
    fill: "#019EF7"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9527 10.6292H19.0479V11.8963H30.9527V10.6292Z",
    fill: "#027BC7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9995 3.57153H38.0947V15.4763H49.9995V3.57153Z",
    fill: "#CCE5FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3053 3.57153H42.7793V7.20634H45.3053V3.57153Z",
    fill: "#019EF7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9995 14.2007H38.0947V15.4679H49.9995V14.2007Z",
    fill: "#027BC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPack);
export default __webpack_public_path__ + "static/media/pack.bf94176154c91dd3cf5400416026466e.svg";
export { ForwardRef as ReactComponent };